module.exports = "pegasus_template/assets/preview-6.png";